import styled from 'styled-components';

export const AnnouncementTitle = styled.div`
  width: 100%;
  padding: 15px 20px;
  border-bottom: 1px solid ${({ theme }) => theme['warmgray-100']};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

export const AnnouncementContent = styled.div`
  width: 100%;
  padding: 15px 20px;
`;
